import React from "react";
import Player from "../cctv/playerorigin";
const Sensor = ({ name, cctvlist, show = false }) => {
  return (
    <div className="container-fluid ">
      {cctvlist && cctvlist.length > 0 && show ? (
        <div className="d-flex align-items-center justify-content-center">
          <div className="col-lg-6 xxl-6 r">
            <Player url={cctvlist[0].hlsss} autoplay={true} />
          </div>
        </div>
      ) : null}

      <div className="row my-4">
        <div className="col-3 p-0">
          <div
            type="button"
            className="btn btn position-relative d-flex align-items-center justify-content-center"
            style={{
              maxWidth: "1200px",
              height: "300px",
              backgroundColor: "#DCDCDC",
            }}
          >
            <span className="fs-5 fw-bold ">ทางขึ้น</span>

            <button
              type="button"
              className="position-absolute top-0 start-50 translate-middle-x btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>

            <button
              type="button"
              className="position-absolute bottom-0 start-50 translate-middle-x btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>
          </div>
        </div>
        <div className="col-6 p-0">
          <div
            type="button"
            className="btn btn-light position-relative border-secondary  d-flex align-items-center justify-content-center"
            style={{ maxWidth: "1200px", height: "300px" }}
          >
            <span className="fs-5 fw-bold ">{name}</span>

            <button
              className="position-absolute top-0 start-0 btn btn-sm btn-primary m-2  rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>

            <button
              type="button"
              className="position-absolute top-0 end-0 btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>
            <button
              type="button"
              className="position-absolute bottom-0 start-0 btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>

            <button
              type="button"
              className="position-absolute bottom-0 end-0 btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>
          </div>
        </div>
        <div className="col-3 p-0">
          <div
            type="button"
            className="btn btn position-relative  d-flex align-items-center justify-content-center"
            style={{
              maxWidth: "1200px",
              height: "300px",
              backgroundColor: "#DCDCDC",
            }}
          >
            <span className="fs-5 fw-bold ">ทางลง</span>

            <button
              type="button"
              className="position-absolute top-0 start-50 translate-middle-x btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>

            <button
              type="button"
              className="position-absolute bottom-0 start-50 translate-middle-x btn btn-sm btn-primary m-2 rounded-pill"
              style={{ width: "3rem", height: "3rem" }}
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sensor;
